module.exports = __webpack_public_path__ + "img/27.f84f24d4.jpg";